document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.announcement-marquee__track').forEach(function (track) {
    var original = track.querySelector('.announcement-marquee__content');
    var text = original.textContent;
    var speed = 80; // pixels per second — lower is slower

    function setup() {
      track.innerHTML = '';
      var itemWidth = original.offsetWidth || 300;
      var screenWidth = window.innerWidth;
      var copies = Math.ceil((screenWidth * 2) / itemWidth) + 2;

      for (var i = 0; i < copies; i++) {
        var span = document.createElement('span');
        span.className = 'announcement-marquee__content';
        span.textContent = text;
        if (i > 0) span.setAttribute('aria-hidden', 'true');
        track.appendChild(span);
      }

      var totalWidth = itemWidth * copies;
      var duration = totalWidth / speed;

      track.style.animation = 'none';
      track.style.transform = 'translateX(0)';

      setTimeout(function () {
        track.style.transition = 'none';
        track.style.animation = 'announcement-scroll ' + duration + 's linear infinite';
      }, 50);
    }

    original.style.display = 'inline-block';
    setup();
    window.addEventListener('resize', setup);
  });
  
});